module.exports = __webpack_public_path__ + "img/lg_ring_y_o_null_0@2x.c56c1403.png";